<template>
    <div class="dml-banners dml-banners--text-after-photo" data-t="24.6">
        <div class="dml-banners__content">
            <a :href="url"
               :title="alt"
               class="dml-banners__media"
               :rel="rel"
               data-ga="m_home.click_ecommerce_banner"
               :data-ga-label="alt">
                <picture class="dml-banners__picture">
                    <source :data-srcset="largeSrcSet" media="(min-width: 1280px)">
                    <source :data-srcset="pictures.mediumx2" media="(min-width: 720px)">
                    <source :data-srcset="pictures.smallx2" media="(min-width: 361px)">
                    <img :data-srcset="smallSrcSet"
                         src="data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw=="
                         :alt="alt"
                         class="lazy" />
                </picture>
            </a>
            <div v-if="title" class="dml-banners__description">
                <p class="dml-banners__short-title" v-if="shortTitle">
                    <span>{{ shortTitle }}</span>
                </p>
                <h3>
                    <a :href="url" :rel="rel" class="dml-banners__title">
                        <span v-html="title" class="_dot"></span>
                        <dm-icon name="arrow-right" :width="24" :height="24" />
                    </a>
                </h3>
            </div>
        </div>
    </div>
</template>
<script>
    import IconComponent from '../shared/icon-component.vue';

    export default {
        name: 'dm-banner',
        components: {
            'dm-icon': IconComponent,
        },
        props: {
            rel: String,
            title: String,
            url: String,
            alt: String,
            shortTitle: String,
            pictures: Object,
        },
        computed: {
            smallSrcSet() {
                return `${this.pictures.smallx2} 2x, ${this.pictures.smallx1} 1x`;
            },
            largeSrcSet() {
                return `${this.pictures.largex2} 2x, ${this.pictures.largex1} 1x`;
            },
        }
    };
</script>
